// FASE 05 — S4-B3/B5: modal de confirmacao reutilizado por DESFAZER, HOMOLOGAR e
// CONCLUIR HOMOLOGAÇÃO (espec. secoes 9, 10 e 11 do mockup 29).

import React, { useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface ModalConfirmacaoProps {
  open: boolean;
  titulo: string;
  mensagem: string;
  textoConfirmar?: string;
  onClose: () => void;
  onConfirmar: () => Promise<void> | void;
}

export const ModalConfirmacao: React.FC<ModalConfirmacaoProps> = ({
  open,
  titulo,
  mensagem,
  textoConfirmar = "Confirmar",
  onClose,
  onConfirmar,
}) => {
  const [processando, setProcessando] = useState(false);

  const handleConfirmar = async () => {
    setProcessando(true);
    try {
      await onConfirmar();
    } finally {
      setProcessando(false);
    }
  };

  return (
    <Dialog open={open} onClose={processando ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 600 }}>{titulo}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2">{mensagem}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} variant="outlined" disabled={processando} sx={{ color: "#666", borderColor: "#bdbdbd" }}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirmar}
          variant="contained"
          disabled={processando}
          startIcon={processando ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{ backgroundColor: "#3C90AD", "&:hover": { backgroundColor: "#2d6f87" } }}
        >
          {textoConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
